import {ContactUsScreen, WithPopupLayout} from '@dynamynd/dynamynd';
import React from 'react';
import {compose} from 'redux';
import {withAnalyticsTrackerWeb} from '../core/withAnalyticsTrackerWeb';

const AnalyticsContactUsScreen = compose(withAnalyticsTrackerWeb)(ContactUsScreen as any);

/**
 * Wrapper for the ContactUsScreen to add analytics tracking, PopupLayout, and navigation props passthrough
 * @param props 
 * @returns 
 */
export function ContactNavigator(props: any) {
    return (
        <WithPopupLayout>
            <AnalyticsContactUsScreen {...props} />
        </WithPopupLayout>
    );
}

